import React, { useEffect, useState } from 'react';
import MembersList from '../../components/Admin/Members/Members';
import Loader from '../../components/Loader/Loader';
import { withFirebase } from '../../components/Firebase';
import { useOrganizationStore } from '../../store/organization.store';

const Members = ({ firebase }) => {
  const [members, setMembers] = useState([]);
  const [, setOwnerId] = useState(null);
  const [loading, setLoading] = useState(true);
  const currentOrgId = useOrganizationStore((state) => state.currentOrgId);

  useEffect(() => {
    if (!currentOrgId) {
      setLoading(false);
      return;
    }

    const loadMembers = async () => {
      try {
        setLoading(true);

        // Get org details to find the owner (createdBy)
        const orgDocSnap = await firebase.getOrganization(currentOrgId);
        const orgDoc = orgDocSnap.exists() ? orgDocSnap.data() : null;
        const orgOwnerId = orgDoc?.createdBy || null;
        setOwnerId(orgOwnerId);

        // Get members from subcollection
        const orgMembers = await firebase.getOrgMembers(currentOrgId);

        // Check if owner is already in members list
        const ownerInMembers = orgMembers.some(m => m.id === orgOwnerId);

        // If owner is not in members list, fetch their details and add them
        if (orgOwnerId && !ownerInMembers) {
          try {
            const ownerDetails = await firebase.getUserDetails(orgOwnerId);
            const ownerMember = {
              id: orgOwnerId,
              username: ownerDetails?.username || null,
              email: ownerDetails?.email || null,
              role: 'OWNER',
              joinedAt: orgDoc?.createdAt || null,
              isOwner: true,
            };
            setMembers([ownerMember, ...orgMembers]);
          } catch (err) {
            console.error('Error fetching owner details:', err);
            setMembers(orgMembers);
          }
        } else {
          // Mark the owner in the existing members list
          const membersWithOwnerFlag = orgMembers.map(m => ({
            ...m,
            isOwner: m.id === orgOwnerId,
          }));
          setMembers(membersWithOwnerFlag);
        }
      } catch (err) {
        console.error('Error loading members:', err);
      } finally {
        setLoading(false);
      }
    };

    loadMembers();
  }, [firebase, currentOrgId]);

  const handleRefresh = async () => {
    if (!currentOrgId) return;
    setLoading(true);
    try {
      // Get org details to find the owner (createdBy)
      const orgDocSnap = await firebase.getOrganization(currentOrgId);
      const orgDoc = orgDocSnap.exists() ? orgDocSnap.data() : null;
      const orgOwnerId = orgDoc?.createdBy || null;
      setOwnerId(orgOwnerId);

      // Get members from subcollection
      const orgMembers = await firebase.getOrgMembers(currentOrgId);

      // Check if owner is already in members list
      const ownerInMembers = orgMembers.some(m => m.id === orgOwnerId);

      // If owner is not in members list, fetch their details and add them
      if (orgOwnerId && !ownerInMembers) {
        try {
          const ownerDetails = await firebase.getUserDetails(orgOwnerId);
          const ownerMember = {
            id: orgOwnerId,
            username: ownerDetails?.username || null,
            email: ownerDetails?.email || null,
            role: 'OWNER',
            joinedAt: orgDoc?.createdAt || null,
            isOwner: true,
          };
          setMembers([ownerMember, ...orgMembers]);
        } catch (err) {
          console.error('Error fetching owner details:', err);
          setMembers(orgMembers);
        }
      } else {
        // Mark the owner in the existing members list
        const membersWithOwnerFlag = orgMembers.map(m => ({
          ...m,
          isOwner: m.id === orgOwnerId,
        }));
        setMembers(membersWithOwnerFlag);
      }
    } catch (err) {
      console.error('Error refreshing members:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="pt-3">
        {loading ? (
          <Loader />
        ) : (
          <MembersList
            members={members}
            firebase={firebase}
            orgId={currentOrgId}
            onRefresh={handleRefresh}
          />
        )}
      </div>
    </>
  );
};

export default withFirebase(Members);
